
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.844 1.969c-.2 0-.381.069-.531.218L9.905 3.5l-1.594-.313c-.5-.1-.806.226-.906.626l-.312 1.78-1.688.813c-.4.2-.512.6-.312 1L5.906 9l-.812 1.594c-.2.4.012.8.312 1l1.688.812.312 1.781c.1.4.506.726.907.626l1.874-.313 1.407 1.313c.3.3.793.3 1.094 0l1.406-1.313 1.906.313c.4.1.806-.226.906-.626l.282-1.78 1.718-.813c.4-.2.482-.6.282-1L18.093 9l.812-1.594c.2-.4.088-.8-.312-1l-1.688-.812-.312-1.782c-.1-.4-.507-.724-.907-.624l-1.874.312-1.407-1.313a.798.798 0 00-.562-.218zm-5.75 11.125L3 19.313l3.594-.5L8.406 22 11 16.687l-.188-.187-1-.906-1.406.219c-.9.1-1.8-.507-2-1.407l-.218-1.312h-.094zm11.812 0l-.312 1.312c-.2.8-.888 1.406-1.688 1.406h-.219l-1.374-.218-1 .906-.22.188L15.689 22l1.812-3.094 3.594.5-3.188-6.312z"}})])
          )
        }
      }
    